module.exports = __webpack_public_path__ + "img/zhangyh.79a0d4b3.png";